import { useI18n } from '../i18n';
import { describeError } from '../lib/errors';
import { Callout } from './Callout';

/**
 * A failure the user can act on: what went wrong, with the real numbers, and a
 * retry button when retrying could plausibly work.
 */
export function ErrorNotice({
  error,
  onRetry,
  title,
}: {
  error: unknown;
  onRetry?: () => void;
  title?: string;
}) {
  const i18n = useI18n();
  const { message, retryable } = describeError(error, i18n);

  return (
    <Callout tone="error" title={title ?? i18n.t('error.title')}>
      <p>{message}</p>
      {retryable && onRetry ? (
        <div className="button-row">
          <button type="button" className="button" onClick={onRetry}>
            {i18n.t('common.retry')}
          </button>
        </div>
      ) : null}
    </Callout>
  );
}
